import classNames from 'classnames';
import React from 'react';
import css from './Step.module.css';

type Props = {
  className?: string;
  number: number;
  title?: string;

  lineStyle?: 'double' | 'dotted' | 'none'; // Default is 'double'
  circleStyle?: 'shadow';
  numberStyle?: 'bold';
};

export const StepLine: React.FC<Pick<Props, 'lineStyle'>> = ({ lineStyle }) => {
  switch (lineStyle) {
    case 'dotted':
      return <span className={css.lineDotted} />;

    case 'none':
      return null;
    case 'double':
    default:
      return <span className={css.lineDouble} />;
  }
};
export const Step: React.FC<Props> = ({
  className,
  number,
  title,
  children,
  lineStyle,
  circleStyle = '',
  numberStyle = '',
}) => {
  return (
    <div className={classNames(className, css.container)}>
      <span className={css.step}>
        <span
          className={classNames(css.circle, {
            [circleStyle]: !!circleStyle,
          })}
        >
          <span
            className={classNames(css.number, {
              [numberStyle]: !!numberStyle,
            })}
          >
            {number}
          </span>
        </span>
        <StepLine lineStyle={lineStyle} />
      </span>

      {title && <span className={css.title}>{title}</span>}

      {children}
    </div>
  );
};
